<header class="header">
  <div class="header-left">
    <button mat-icon-button class="menu-btn" (click)="menuToggle.emit()">
      <mat-icon fontSet="material-icons-outlined">menu</mat-icon>
    </button>

    <nav class="breadcrumbs" aria-label="Breadcrumb">
      @for (crumb of breadcrumbs.breadcrumbs(); track crumb.url; let last = $last) {
        @if (!last) {
          <a class="breadcrumb-link" [routerLink]="crumb.url">{{ crumb.label }}</a>
          <mat-icon class="breadcrumb-sep">chevron_right</mat-icon>
        } @else {
          <span class="breadcrumb-current">{{ crumb.label }}</span>
        }
      }
    </nav>
  </div>

  <div class="header-right">
    <!-- Search trigger -->
    <div class="search-wrapper" (click)="openSearch()">
      <mat-icon class="search-icon" fontSet="material-icons-outlined">search</mat-icon>
      <span class="search-placeholder">Search documents, memos, people...</span>
      <kbd class="search-shortcut">⌘K</kbd>
    </div>
    <button mat-icon-button class="search-toggle" (click)="openSearch()">
      <mat-icon fontSet="material-icons-outlined">search</mat-icon>
    </button>

    <!-- Dark mode -->
    <button mat-icon-button class="header-action" (click)="theme.toggleTheme()">
      <mat-icon fontSet="material-icons-outlined">
        {{ theme.isDark() ? 'light_mode' : 'dark_mode' }}
      </mat-icon>
    </button>

    <!-- Notifications -->
    <button mat-icon-button class="header-action notification-btn" (click)="toggleNotifications()">
      <mat-icon fontSet="material-icons-outlined">notifications</mat-icon>
      @if (notifications.unreadCount() > 0) {
        <span class="notification-badge"></span>
      }
    </button>

    <!-- User avatar -->
    <div class="user-menu">
      <div class="user-avatar">IU</div>
      <span class="user-name">Ibrahim Umar</span>
    </div>
  </div>
</header>

<app-notification-panel #notifPanel />
<app-toast-container />

@if (searchOpen()) {
  <nf-search-overlay (close)="closeSearch()" />
}
